import axios from 'axios'

export function fetchRoles () {
  return axios.get('/roles')
}

export function fetchRole (id: number|string) {
  return axios.get('/roles/' + id)
}

export function createRole (data: Record<string, any>) {
  return axios.post('/roles', data)
}

export function updateRole (id: number|string, data: Record<string, any>) {
  return axios.put('/roles/' + id, data)
}

export function deleteRole (id: number|string) {
  return axios.delete('/roles/' + id)
}
